<template>

  <HeaderSectionCharlas />

  <section id="formulario" class="bg-gray-100 py-12" style="font-family: PlexRegular;">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700"
      @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto px-4 max-w-5xl pb-16">

        <h1 class="font-bold text-gray-800 mb-4 text-2xl text-center uppercase"
          style="color: rgb(41 57 152); font-family: PlexSemiBold;">
          {{ franjaSeleccionada ? franjaSeleccionada.descripcionExtra1 : '' }}
        </h1>
        <div v-if="franjaSeleccionada" class="text-center pb-5">
          <p class="text-lg font-semibold text-gray-600 mb-1">{{ descripcionTurno }} {{ franjaSeleccionada.franjaHoraria
            }}</p>
          <p class="text-md text-gray-500">Sala : {{ franjaSeleccionada.descripcionExtra2 }}</p>
        </div>

        <!-- Nombre y Apellido -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" placeholder="Ingrese su nombre" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombre" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" placeholder="Ingrese su apellido" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="apellido" />
              </span>
            </Field>
          </div>
        </div>

        <!-- DNI y Email -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">DNI</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="text" placeholder="Ingrese su DNI" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="documento" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Email</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="text" placeholder="Ingrese su email" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="mail" />
              </span>
            </Field>
          </div>
        </div>

        <!-- País, Provincia y Ciudad/Localidad -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <!-- País de residencia -->
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">País de residencia</label>
            <Field name="pais" v-slot="{ handleChange, handleBlur, value, errors }" v-model="selectedCountry">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" filter
                :options="paises" optionLabel="value" placeholder="Seleccione un País" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="pais" />
              </span>
            </Field>
          </div>

          <!-- Provincia/estado select vs input -->
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Provincia / Estado</label>
            <div v-if="selectedCountry?.value === 'Argentina'">
              <Field name="provinciaSelect" v-slot="{ handleChange, handleBlur, value, errors }"
                v-model="formData.provinciaSelect">
                <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" filter
                  placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion"
                  class="input-base"
                  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage name="provinciaSelect" />
                </span>
              </Field>
            </div>
            <div v-else>
              <Field name="provinciaInput" v-slot="{ field, errors }" v-model="formData.provinciaInput">
                <InputText v-bind="field" type="text" placeholder="Ingrese su provincia/estado" class="input-base"
                  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage name="provinciaInput" />
                </span>
              </Field>
            </div>
          </div>

          <!-- Ciudad/Localidad select vs input -->
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Ciudad / Localidad</label>
            <div v-if="selectedCountry?.value === 'Argentina'">
              <Field name="localidadSelect" v-slot="{ handleChange, handleBlur, value, errors }"
                v-model="formData.localidadSelect">
                <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" filter
                  placeholder="Seleccione la localidad" :options="localidades" optionLabel="descripcion"
                  class="input-base"
                  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage name="localidadSelect" />
                </span>
              </Field>
            </div>
            <div v-else>
              <Field name="ciudadInput" v-slot="{ field, errors }" v-model="formData.ciudadInput">
                <InputText v-bind="field" type="text" placeholder="Ingrese su ciudad/localidad" class="input-base"
                  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage name="ciudadInput" />
                </span>
              </Field>
            </div>
          </div>
        </div>

        <!-- Teléfono -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">País</label>
            <Select v-model="selectedPhoneCountry" filter :options="paises" optionLabel="value"
              placeholder="Seleccione un País" class="input-base" />
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" :model-value="selectedPhoneCountry ? selectedPhoneCountry.code : ''"
              class="input-base" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" placeholder="Cód. Área (sin 0)" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="codigoArea" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text" placeholder="Celular (sin 15)" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="telefonoCelular" />
              </span>
            </Field>
          </div>
        </div>

        <!-- Nacionalidad y Rubro -->
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Nacionalidad</label>
            <Field name="nacionalidad" v-slot="{ field, errors }" v-model="formData.nacionalidad">
              <InputText v-bind="field" type="text" placeholder="Ingrese su nacionalidad" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nacionalidad" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Profesión:</label>
            <Field name="rubro" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.rubro">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                placeholder="Seleccione una opción" :options="rubros" optionLabel="descripcion" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="rubro" />
              </span>
            </Field>
          </div>
        </div>

        <!-- Aceptar -->
        <div class="flex flex-wrap py-2 mt-6">
          <button type="submit"
            class="px-6 py-3 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded-lg cursor-pointer transition-colors duration-350"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>ACEPTAR
          </button>
        </div>

      </div>
    </Form>

    <BlockUI :blocked="isSubmitting" fullScreen />

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import HeaderSectionCharlas from './HeaderSectionCharlas.vue';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import BlockUI from 'primevue/blockui';

import jsonCountries from '@/data/countries.json';
import jsonRubros from '@/data/rubros.json';
import jsonProvincias from '@/data/provincias.json';
import jsonLocalidades from '@/data/localidades.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, OrigenAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { VERIFICADO, SAVE, ORIGEN_ACREDITADO } from "qreventos-suite/constantes";
import turnosService, { FranjaDisponible } from 'qreventos-suite/turnos';

interface Pais {
  code: string;
  value: string;
}

interface Provincia {
  id: number;
  descripcion: string;
}

interface Localidad {
  id: number;
  descripcion: string;
}

export default defineComponent({
  components: {
    HeaderSectionCharlas,
    InputText, Select, BlockUI,
    Field, ErrorMessage, Form
  },
  created() {
    document.title = "Expo Rural 2026 - Acreditación";
  },
  data() {
    return {
      isSubmitting: false,
      paises: jsonCountries as Pais[],
      rubros: jsonRubros,
      selectedCountry: { "code": "+54", "value": "Argentina" } as Pais,
      selectedPhoneCountry: { "code": "+54", "value": "Argentina" } as Pais,
      formData: {
        nombre: '',
        apellido: '',
        mail: '',
        documento: '',
        codigoArea: '',
        telefonoCelular: '',
        nacionalidad: '',
        provinciaInput: '',
        ciudadInput: '',
        provinciaSelect: undefined as any,
        localidadSelect: undefined as any,
        rubro: undefined as any
      },
      provincias: jsonProvincias as Provincia[],
      localidades: [] as Localidad[],
      turnoId: null as number | null,
      charlaId: null as number | null,
      franjaSeleccionada: null as FranjaDisponible | null,
      descripcionTurno: ''
    };
  },
  computed: {
    schema() {
      const isArgentina = this.selectedCountry?.value === 'Argentina';
      return yup.object({
        nombre: yup.string().required('Ingrese su nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese su apellido').min(2, 'Al menos 2 letras'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
        documento: yup.string().required('El DNI es obligatorio').matches(/^[0-9]+$/, 'Solo se permiten números').min(6, 'Debe tener al menos 6 caracteres'),
        nacionalidad: yup.string().required('La nacionalidad es obligatoria'),
        pais: yup.object().required('Seleccione el país de residencia'),
        codigoArea: yup.string().required('Ingrese el código de área').matches(/^\d+$/, 'Solo números').min(2, 'Al menos 2 números'),
        telefonoCelular: yup.string().required('Ingrese el celular').matches(/^\d+$/, 'Solo números').min(5, 'Al menos 5 números'),
        rubro: yup.object().required('Seleccione su rubro'),
        provinciaInput: yup.string().test('req-provincia-extranjero', 'Ingrese la provincia/estado', function (value) {
          if (!isArgentina && !value) return false;
          return true;
        }),
        ciudadInput: yup.string().test('req-ciudad-extranjero', 'Ingrese la ciudad/localidad', function (value) {
          if (!isArgentina && !value) return false;
          return true;
        }),
        provinciaSelect: yup.mixed().test('req-provincia-argentina', 'Seleccione la provincia', function (value) {
          if (isArgentina && !value) return false;
          return true;
        }),
        localidadSelect: yup.mixed().test('req-localidad-argentina', 'Seleccione la localidad', function (value) {
          if (isArgentina && !value) return false;
          return true;
        })
      });
    }
  },
  watch: {
    selectedCountry() {
      this.formData.provinciaInput = '';
      this.formData.ciudadInput = '';
      this.formData.provinciaSelect = undefined;
      this.formData.localidadSelect = undefined;
    },
    'formData.provinciaSelect'(newValue) {
      if (newValue && newValue.id) {
        this.localidades = (jsonLocalidades as Localidad[]).filter((l: Localidad) => l.id === newValue.id);
        this.formData.localidadSelect = undefined;
      } else {
        this.localidades = [];
        this.formData.localidadSelect = undefined;
      }
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Revise el formulario<br>Hay " + errores + " error/es", icon: "error" });
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {

        if (this.turnoId == null || this.charlaId == null) {
          Swal.fire({
            title: "Atención",
            text: "La charla es inválida o está completa.",
            icon: "warning",
            confirmButtonText: "Aceptar"
          }).then(() => {
            window.location.href = "https://www.exposicionrural.com.ar/";
          });
          return;
        }
        const franjas = await turnosService.findFranjasDisponiblesBy(suiteConfig.evento, this.turnoId);
        const franjaEncontrada = franjas.find(f => f.id === this.charlaId);

        if (!franjaEncontrada) {
          Swal.fire({
            title: "Atención",
            text: "La charla es inválida o está completa.",
            icon: "warning",
            confirmButtonText: "Aceptar"
          }).then(() => {
            window.location.href = "https://www.exposicionrural.com.ar/";
          });
          return;
        }

        let acreditado: Acreditado = new Object() as Acreditado;
        acreditado.tipoAcreditado = { "id": 2471 } as TipoAcreditado;
        acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
        acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
        acreditado.modificado = SAVE;
        acreditado.cantidad = 1;
        acreditado.notificar = true;
        acreditado.notificarWhatsApp = false;

        acreditado.dato8 = this.formData.documento;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.mail = this.formData.mail;
        acreditado.telefono = (this.selectedPhoneCountry ? this.selectedPhoneCountry.code : '') + this.formData.codigoArea + this.formData.telefonoCelular;

        acreditado.dato1 = this.formData.nacionalidad;
        acreditado.dato2 = this.selectedCountry ? this.selectedCountry.value : '';

        if (this.selectedCountry?.value === 'Argentina') {
          acreditado.dato3 = this.formData.localidadSelect ? this.formData.localidadSelect.descripcion : '';
          acreditado.dato4 = this.formData.provinciaSelect ? this.formData.provinciaSelect.descripcion : '';
        } else {
          acreditado.dato3 = this.formData.ciudadInput;
          acreditado.dato4 = this.formData.provinciaInput;
        }

        acreditado.dato5 = this.formData.rubro ? this.formData.rubro.descripcion : '';

        acreditado.dato6 = this.descripcionTurno;
        acreditado.dato7 = this.franjaSeleccionada
          ? this.franjaSeleccionada.descripcionExtra1 + " - " + this.franjaSeleccionada.franjaHoraria
          : '';

        const acreditadoGuardado = await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

        if (this.charlaId) {
          await turnosService.asignarTurno(suiteConfig.evento, this.charlaId, acreditadoGuardado);
        }

        Swal.fire({
          title: "Acreditación exitosa",
          html: "Estimado/a: hemos recibido sus datos con éxito.<br/><br/>Le enviamos un mail para informarle el estado de su registración. <br/><br/>Por favor revise su casilla de correo y de spam.",
          icon: "success",
        }).then(() => {
          this.$router.push({ path: '/finalizado' });
        });

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
      return;
    }
  },
  async mounted() {
    const turnoParam = this.$route.query.turno;
    const charlaParam = this.$route.query.charla;

    if (!turnoParam || !charlaParam) {
      Swal.fire({
        title: "Atención",
        text: "La charla no existe",
        icon: "warning",
        confirmButtonText: "Aceptar"
      }).then(() => {
        window.location.href = "https://www.exposicionrural.com.ar/";
      });
      return;
    }

    const turnoId = Number(turnoParam);
    const charlaId = Number(charlaParam);

    if (isNaN(turnoId) || isNaN(charlaId)) {
      Swal.fire({
        title: "Atención",
        text: "La charla no existe",
        icon: "warning",
        confirmButtonText: "Aceptar"
      }).then(() => {
        window.location.href = "https://www.exposicionrural.com.ar/";
      });
      return;
    }

    try {
      this.isSubmitting = true;
      const franjas = await turnosService.findFranjasDisponiblesBy(suiteConfig.evento, turnoId);
      const franjaEncontrada = franjas.find(f => f.id === charlaId);

      if (!franjaEncontrada) {
        Swal.fire({
          title: "Atención",
          text: "La charla es inválida o está completa.",
          icon: "warning",
          confirmButtonText: "Aceptar"
        }).then(() => {
          window.location.href = "https://www.exposicionrural.com.ar/";
        });
        return;
      }

      this.turnoId = turnoId;
      this.charlaId = charlaId;
      this.franjaSeleccionada = franjaEncontrada;

      const turnos = await turnosService.findTurnosDisponiblesBy(suiteConfig.evento);
      console.log(turnos);
      const turnoEncontrado = turnos.find(t => t.id === turnoId);
      this.descripcionTurno = turnoEncontrado ? turnoEncontrado.descripcion : '';
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error",
        text: "Hubo un error al validar la charla.",
        icon: "error",
        confirmButtonText: "Aceptar"
      }).then(() => {
        window.location.href = "https://www.exposicionrural.com.ar/";
      });
    } finally {
      this.isSubmitting = false;
    }
  }
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>